import pick from 'lodash/fp/pick';
import {connect} from 'react-redux';
import {getResources} from 'redux-resource';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import withHandlers from 'recompose/withHandlers';
import {setLanguage} from '../../../../redux/actions/languages';
import LanguageSelect from './select';

function mapStateToProps(state) {
	const languages = getResources(state.languages, 'all');
	const value = state.languages.switchValue;

	return {
		languages, value
	};
}

function mapDispatchToProps(dispatch) {
	return {
		setLanguage: lang => {
			dispatch(setLanguage(lang));
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	withHandlers({
		handleChange: props => event => {
			props.setLanguage(event.target.value);
		}
	}),
	mapProps(pick([
		'classes',
		'languages',
		'handleChange',
		'value'
	]))
);

export default enhance(LanguageSelect);



// WEBPACK FOOTER //
// ./src/client/components/main/collections/language-select/index.js